import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'

import { Color, Size } from 'const'
import { Button, Pager } from 'components/shard'
import Alert from 'components/Alert'

import { useNewsHook } from 'hooks'
import WrapperLink from 'components/shard/WrapperLink'

function NewsMobile() {
  const {
    id,
    name,
    page,
    newsInfos,

    // notice関連
    notice,
    isNoticeRequestingAPI,
    noticeErrors,
    setNoticeErrors,
    getNotice,

    // notices関連
    notices,
    isNoticesRequestingAPI,
    noticesErrors,
    setNoticesErrors,
    getNotices,
  } = useNewsHook()

  useEffect(() => {
    id ? getNotice() : getNotices()
  }, [id, getNotice, getNotices])

  return (
    <NewsArea>
      {noticeErrors.length > 0 && (
        <Alert
          type="error"
          message="エラー"
          description={noticeErrors.join('\n')}
          onClose={() => setNoticeErrors([])}
        />
      )}
      {noticesErrors.length > 0 && (
        <Alert
          type="error"
          message="エラー"
          description={noticesErrors.join('\n')}
          onClose={() => setNoticesErrors([])}
        />
      )}
      {isNoticeRequestingAPI || isNoticesRequestingAPI ? (
        <TitleColumn>お知らせの確認中。</TitleColumn>
      ) : id && !_.isEmpty(notice) && !_.isEmpty(newsInfos[notice.template_id]) ? (
        <NewsDetail name={name} notice={notice} newsInfos={newsInfos} />
      ) : !id && !_.isEmpty(notices?.notices) > 0 ? (
        <>
          <NewsList notices={notices.notices} newsInfos={newsInfos} />
          <MarginArea />
          <Pager link="/news?page=" page={page} max={notices.total_pages} />
        </>
      ) : (
        <TitleColumn>お知らせはございません。</TitleColumn>
      )}
    </NewsArea>
  )
}

function NewsDetail({ name, notice, newsInfos }) {
  return (
    <Wrapper>
      <TitleBlock>
        <DateColumn>{notice.date}</DateColumn>
        <TitleColumn>
          <StrongSpan>重要</StrongSpan> {newsInfos[notice.template_id].title}
        </TitleColumn>
      </TitleBlock>
      <Separator />
      <TextColumn>
        {name}様
        <br />
        {newsInfos[notice.template_id].msg}
      </TextColumn>
      <Separator />
      <ButtonWrapper>
        <NextLink to="/news">
          <Button type="button" primary>
            一覧へ戻る
          </Button>
        </NextLink>
      </ButtonWrapper>
    </Wrapper>
  )
}

function NewsList({ notices, newsInfos }) {
  return _.map(notices, (notice) => (
    <Row key={notice.id}>
      <NextLink to={`/news/${notice.id}`}>
        <DateColumn>{notice.date}</DateColumn>
        <TitleColumn>
          <StrongSpan>重要</StrongSpan> {newsInfos[notice.template_id].title}
        </TitleColumn>
      </NextLink>
    </Row>
  ))
}

const Wrapper = styled.div``
const NewsArea = styled.div`
  padding: 35px 35px 33px 35px;
`
const NextLink = styled(WrapperLink)`
  text-decoration: none;
`
const Row = styled.div`
  padding-bottom: 30px;
`
const DateColumn = styled.div`
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  padding-bottom: 10px;
`
const TitleColumn = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
`
const StrongSpan = styled.span`
  color: ${Color.FONT.DANGER};
`
const MarginArea = styled.div`
  padding-bottom: 14px;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`
const TitleBlock = styled.div`
  padding-bottom: 23px;
`
const TextColumn = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  padding: 18px 0 125px 0;
  font-weight: 300;
  line-height: 1.88;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 21px;
`

NewsDetail.propTypes = {
  name: PropTypes.string,
  notice: PropTypes.object,
  newsInfos: PropTypes.object,
}

NewsList.propTypes = {
  notices: PropTypes.array,
  newsInfos: PropTypes.object,
}

export default NewsMobile
